module.exports = __webpack_public_path__ + "cuba.svg?ef70ab2e91432b0e712675857199d557";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/cuba.svg
// module id = 144
// module chunks = 10